// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__4FIRr","title":"styles_title__-uzU9","column":"styles_column__21Wtc","select":"styles_select__USa1V"};